import { JobListing } from '~/types/hlx/jobListing';
import { MsaasJobListing } from '~/types/hlx/msaasJobListing';
import { emptyAdditionalTermsForm } from './constants';
import { AdditionalTermsFormValues } from './types';

export const transformApiToAdditionalTermsForm = (
  listing: MsaasJobListing | JobListing
): AdditionalTermsFormValues => {
  return {
    ...emptyAdditionalTermsForm,
    id: listing.detail?.id,
    msaasListingId: listing.id,
    bonusesTxt: listing.detail?.bonusesTxt,
    adminCostsTxt: listing.detail?.adminCostsTxt,
    infrastructureTxt: listing.detail?.infrastructureTxt,
    extraTxt: listing.detail?.extraTxt,
  };
};
